module.exports = __webpack_public_path__ + "img/5.7807d9f4.png";